import React, { Component } from 'react';

class IconDeleteWhite extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="none"
                viewBox="0 0 25 25"
            >
                <g clipPath="url(#clip0_1794_12506)">
                    <path
                        fill="#fff"
                        d="M12.413.754a11.64 11.64 0 00-6.527 2.005A11.871 11.871 0 001.558 8.1a12.049 12.049 0 00-.67 6.878 11.952 11.952 0 003.215 6.095 11.701 11.701 0 006.015 3.258c2.28.46 4.641.224 6.788-.676a11.783 11.783 0 005.273-4.384 12.015 12.015 0 001.981-6.613c0-1.563-.303-3.111-.893-4.555A11.912 11.912 0 0020.72 4.24a11.738 11.738 0 00-3.812-2.58 11.613 11.613 0 00-4.496-.906z"
                    ></path>
                    <path
                        fill="#1D53A5"
                        d="M18.221 6.317H14.87l-.263-.529a.672.672 0 00-.6-.376h-3.193a.66.66 0 00-.598.376l-.263.53H6.602a.442.442 0 00-.413.28.458.458 0 00-.034.173v.905c0 .12.047.235.131.32a.444.444 0 00.316.132H18.22a.443.443 0 00.316-.132c.084-.085.13-.2.13-.32V6.77a.458.458 0 00-.275-.42.441.441 0 00-.171-.034zM7.641 18.631c.021.345.17.668.418.904.248.236.575.369.915.37h6.866c.34-.001.667-.134.915-.37s.397-.56.418-.904l.601-9.597H7.05l.592 9.597z"
                    ></path>
                </g>
                <defs>
                    <clipPath id="clip0_1794_12506">
                        <path
                            fill="#fff"
                            d="M0 0H23.496V23.805H0z"
                            transform="translate(.664 .754)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconDeleteWhite;